import { render } from "./BlocCarteNombres.vue?vue&type=template&id=040bbce0"
import script from "./BlocCarteNombres.vue?vue&type=script&lang=js"
export * from "./BlocCarteNombres.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__